import { Menu, Transition } from '@headlessui/react';
import clsx from 'clsx';
import React, { Fragment } from 'react';
import Avatar from 'react-avatar';
import { useGetUserProfile } from '../api/userprofile';
import useAuthStore from '@/features/auth/stores/authStore';

export const ProfileMenu = () => {
  const { data } = useGetUserProfile();

  return (
    <Menu as="div" className="relative ml-3">
      <div>
        <Menu.Button
          className="flex text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
          data-cy="user-menu"
        >
          <span className="sr-only">Open user menu</span>
          <Avatar
            name={data ? `${data.firstName} ${data.lastName}` : ''}
            maxInitials={2}
            round={true}
            size="32"
          />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-20 w-48 py-1 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {/* <Menu.Item> TODO: Add logic to open profile screen when it gets developed
						{({ active }) => (
							<a
								href="#"
								className={clsx(
									active ? 'bg-gray-100' : '',
									'block px-4 py-2 text-sm text-gray-700'
								)}
							>
								Your Profile
							</a>
						)}
					</Menu.Item> */}
          <Menu.Item>
            {({ active }) => (
              <a
                href="/logout"
                className={clsx(
                  active ? 'bg-gray-100' : '',
                  'block px-4 py-2 text-sm text-gray-700'
                )}
                data-cy="user-menu-sign-out"
              >
								Sign out
              </a>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export const MobileProfileMenu = () => {
  const { data } = useGetUserProfile();
  const email: string | undefined = useAuthStore((x) => x.domainUser?.email);

  return (
    <>
      <div className="shrink-0">
        <Avatar
          name={`${data?.firstName} ${data?.lastName}`}
          maxInitials={2}
          round={true}
          size="40"
        />
      </div>
      <div className="ml-3">
        <div className="text-base font-medium text-white">{`${data?.firstName} ${data?.lastName}`}</div>
        <div className="text-sm font-medium text-gray-400">{email}</div>
      </div>
    </>
  );
};
